import { useDialog } from '@/ui-plus/dialog/use-dialog';
import UpdateNameForm from '@auth-frontend-vue/components/forms/UpdateNameForm.vue';

const dialog = useDialog();

export function showNameForm() {
    return new Promise<number>((resolve) => {
        dialog.show({
            title: 'Your name is required',
            closeable: false,
            description: 'Please enter your name. This is a one-time process and will not be required in the future.',
            component: UpdateNameForm,
            props: {
                showCancel: false,
            },
            onSuccess: () => {
                resolve(1);
            },
            onError: () => {
                resolve(-1);
            },
            onCancel: () => {
                resolve(-1);
            }
        })
    })
}
